import { combineReducers } from 'redux'
import view from './view'
import userGroups from './userGroups'

export default combineReducers({
  view,
  userGroups
})
